var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationNoread(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.112,
    height: 12.2,
    viewBox: "0 0 17.112 12.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9377",
    "data-name": "Group 9377",
    transform: "translate(-231.372 -376.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M233.062,377.223a6.721,6.721,0,0,1,1.231-.266q7.124-.021,14.247,0a5.685,5.685,0,0,1,1.125.259c-.227.271-.336.43-.472.561-1.892,1.813-3.775,3.636-5.687,5.428s-2.308,1.8-4.218,0c-1.893-1.78-3.768-3.579-5.649-5.371C233.495,377.7,233.367,377.552,233.062,377.223Z",
    transform: "translate(-1.463)",
    fill: "#004d72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M234.142,431.138q1.5-1.434,3-2.868c.7-.665,1.405-1.319,2.08-2.005.293-.3.5-.371.819-.034a6.277,6.277,0,0,0,.922.78,1.983,1.983,0,0,0,2.707,0c.128-.09.249-.191.37-.291,1-.82.991-.815,1.9.062q2.035,1.955,4.088,3.892a3.428,3.428,0,0,0,.571.361l-.1.282a3.647,3.647,0,0,1-.955.274q-7.191.027-14.382,0a4.468,4.468,0,0,1-.994-.232Z",
    transform: "translate(-2.397 -42.459)",
    fill: "#004d72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M323.157,393.826l-5.5-5.239,5.5-5.241Z",
    transform: "translate(-74.672 -5.536)",
    fill: "#004d72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M231.372,383.386l5.5,5.238-5.5,5.234Z",
    transform: "translate(0 -5.572)",
    fill: "#004d72"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNoread);
export default __webpack_public_path__ + "static/media/notification-noread.27f996e4eb1117989bd8530dcf9d0587.svg";
export { ForwardRef as ReactComponent };